import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const jobCopyIntegrationItemFragment = gql`
  fragment jobCopyIntegrationItemFragment on JobCopyIntegrationItem {
    id
    integrationID
    remoteID
    integrationItem {
      ...integrationItemFragment
    }
    jobCopyIntegrationItemState
    newRemoteID
    newIntegrationItem {
      ...integrationItemFragment
    }
    newIntegrationID
    newName
    newParentRemoteID
    progressCount
    progressTotal
  }
  ${integrationItemFragment}
`;

export default jobCopyIntegrationItemFragment;
